<div class="container-fluid dashboard-body">
  <student-info-panel
    (newStudentData)="changeStudentData($event)"
    (newSchoolEvent)="updateSchool($event)"
  ></student-info-panel>
  <messaging [errorMessage]="errorMessage"></messaging>
  <div *ngIf="studentProfile">
    <panel
      [metadata]="panel"
      [level]="studentProfile.entityLevel"
      [entityId]="studentProfile.entityId"
      [studentFirstName]="student.firstName"
      [role]="role"
      [custId]="custId"
      [schoolMinGradeLevel]="school?.minGradeLevel"
      [tier]="tier"
      *ngFor="let panel of studentProfile.customerFramework?.customerPanels"
    ></panel>
  </div>
  <div *ngIf="!studentProfile" class="placeholder-div"></div>
</div>
